import React from 'react';
import { legalLinks, product } from '../../data/product';
export function SiteFooter() {
  return <footer className="w-full border-t border-sand bg-ivory pb-24 md:pb-0" data-id="element-163" data-mp="30eg1li861nqw">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-6 py-10 text-sm text-stone md:flex-row md:items-center md:justify-between lg:px-10" data-id="element-164" data-mp="35eapdcwn9x7q">
        <span className="font-serif text-base text-carbon" data-id="element-165" data-mp="3a5sqq22kxzt8">
          Buena Vibra<span className="text-gold-ink" data-id="element-166" data-mp="3f4x1gx55k5lo">X</span>
        </span>
        <nav aria-label="Información legal" data-id="element-167" data-mp="3f6ggkkf2oalv">
          <ul className="flex flex-col gap-3 sm:flex-row sm:gap-6" data-id="element-168" data-mp="3k25md5hoqnqm">
            {legalLinks.map(link => <li key={link.href} data-id="element-169" data-mp="3o63jxbrd3qhk">
                <a href={link.href} className="text-carbon underline decoration-sand decoration-1 underline-offset-4 transition-colors duration-150 ease-out hover:decoration-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-170" data-mp="3o2zanzz1i4k1">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <span data-id="element-171" data-mp="pd80qlnji9t">
          © 2026 {product.brand} · {product.author}
        </span>
      </div>
    </footer>;
}